import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AdminBaseForm,
  useBlueprintAdmin,
} from '@deloitte-us-consulting-dd/blueprint-ux-admin';

const BenchmarkSubSectorsNew = () => {
  const [sectors, setSectors] = useState<Array<any>>([]);
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { config, adminBenchmarkApi } = useBlueprintAdmin();

  useEffect(() => {
    adminBenchmarkApi!
      .getSectors()
      .then(({ data }) => {
        setSectors(data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const onSuccess = (response) => {
    navigate(`/benchmarks/sub-sectors`);
  };

  const uiSchema = {
    sectorId: { 'ui:widget': 'autoComplete' },
  };

  const schema = {
    properties: {
      name: {
        type: 'string',
      },
      sectorId: {
        type: 'string',
        title: 'Sector',
        enum: sectors.map((sector: any) => sector.id),
        enumNames: sectors.map((sector: any) => sector.name),
        description: '',
      },
    },
    type: 'object',
    required: ['name', 'sectorId'],
  };

  return (
    <AdminBaseForm
      url='/admin/benchmarks/sub-sectors'
      entityTitle='Sub Sectors'
      schema={schema}
      uiSchema={uiSchema}
      onSuccess={onSuccess}
    />
  );
};

export default BenchmarkSubSectorsNew;
